import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData } from "@/data";
import { getTrackFormatQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useGetTrackFormat = (id) => {
    const { isAuthenticated } = useAuth0();

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const { data, error, loading } = useQuery(getTrackFormatQuery, {
        skip: !isAuthenticated || !id,
        variables: {
            trackFormatId: id,
        },
    });

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data: data?.trackFormat,
        loading,
    };
};

export default useGetTrackFormat;
